<template>
    <div>
        <base-layout :hideHeader="!isShowHeader" title="达人荟入会礼活动说明">
            <!--<template slot="header-right">
                <i class="dmicon dm-guanbi1" @click="$router.back()"></i>
            </template>-->
            <template slot="main">
                <div class="docs" v-show="isShowDocs">
                    <h2 v-if="showTitle" style="text-align: center;">达人荟入会礼活动说明</h2>

                    <p class="info-title">■当期活动期限起止日：2020年12月24日至2021年3月24日</p>

                    <ul>
                        <li>
                            一、本说明所使用词语采用《会员章程》同字词语的定义。
                        </li>
                        <li>
                            二、达美乐以手机号为会员身份唯一识别，每个手机号仅可获得一次入会礼。
                        </li>
                        <li>
                            三、适用渠道<strong>（不同入会渠道所得入会礼不相同，且互不同享，只能领取其中一类入会渠道的入会礼）</strong>：
                        </li>
                        <li>
                            (一)达美乐口碑渠道：
                        </li>
                        <li>
                            1.达美乐支付宝口碑渠道指通过口碑注册入会。
                        </li>
                        <li>
                            2.该渠道的入会礼仅限用于在口碑上支付结算所购买达美乐餐品和服务的订单。
                        </li>
                        <li>
                            3.该渠道入会礼内容为“甄选尊享比萨7折”折扣券1张和50个奖励积分。
                        </li>
                        <li>
                            4.该渠道的入会礼仅限到店堂食或外带使用，不适用于外卖、线上订餐等其他方式。
                        </li>
                        <li>
                            5.会员在同一笔订单以餐厅菜单售价购买任意达美乐餐品之后，可使用一张比萨折扣券购买一个甄选尊享的比萨；特殊加价饼皮及额外添加配料不参与比萨优惠券折扣。
                        </li>
                        <li>
                            6.“奖励积分”的使用条件见《会员章程》的“会员积分”章节。积分所兑换的抵扣金额可抵扣订单的实付金额，包括外送费和订单餐品总价。
                        </li>
                        <li>
                            7.奖励积分发放方式：该入会礼的50个奖励积分将在消费者注册成功后加入消费者的达人荟会员帐户对应账户。
                        </li>
                        <li>
                            8.消费者需同时遵循支付宝和口碑的平台规则。
                        </li>
                        <li>
                            (二)达美乐自有入会渠道：
                        </li>
                        <li>
                            1.达美乐自有入会渠道指通过达美乐官网（含Web端、Wap端）、达美乐微信公众号、达美乐App、门店柜台注册、达美乐微信小程序、支付宝生活号入会。
                        </li>
                        <li>
                            2.该渠道入会礼仅限用于达美乐官网、达美乐微信公众号、达美乐App、达美乐微信小程序、支付宝生活号订餐、购买达美乐餐品和服务的结算订单。
                        </li>
                        <li>
                            3.该渠道入会礼内容：
                        </li>
                        <li>
                            (1)50个奖励积分，通过达美乐自有入会渠道入会的会员都可以获得50个奖励积分作为入会礼。
                        </li>
                        <li>
                            (2)消费者通过达美乐官网、达美乐微信公众号、达美乐App、达美乐微信小程序等达美乐自有线上入会渠道注册入会的，可在进入入会礼选择页面5分钟内，在以下4种优惠券中任选2张作为入会礼（确定选择之后将不得更改）：
                        </li>
                        <li>
                            A.“经典风味比萨7折”折扣券1张
                        </li>
                        <li>
                            B.“蜜汁鸡翅一对”兑换券1张
                        </li>
                        <li>
                            C.“意面任选7折”折扣券1张
                        </li>
                        <li>
                            D.“黄金薯角一份”兑换券1张
                        </li>
                        <li class="bold">
                            但是，以下情形下中，系统将默认为消费者自动派发2张指定优惠券（“经典风味比萨7折”折扣券1张和“蜜汁鸡翅一对”兑换券1张）作为入会礼：
                        </li>
                        <li class="bold">
                            A.消费者在门店柜台注册入会；
                        </li>
                        <li class="bold">
                            B.因系统技术限制，消费者通过宝贝厨房活动支付页面的入会链接注册入会的；
                        </li>
                        <li class="bold">
                            C.因系统技术限制，消费者通过领取积分转赠券的入会链接注册入会的；
                        </li>
                        <li class="bold">
                            D.消费者在入会礼券选择页面5分钟内未完成礼券选择；
                        </li>
                        <li class="bold">
                            E.其它消费者未自主选择入会礼优惠券的情景。
                        </li>
                        <li>
                            4.该渠道入会礼的使用限制：
                        </li>
                        <li>
                            (1)“经典风味比萨7折”折扣券的使用条件：会员在同一笔订单以餐厅菜单售价购买任意达美乐餐品之后，可使用一张比萨折扣券购买一个经典风味类型的比萨；特殊加价饼皮及额外添加配料不参与比萨优惠券折扣。
                        </li>
                        <li>
                            (2)“蜜汁鸡翅一对”兑换券的使用条件：会员在同一笔订单以餐厅菜单售价购买任意达美乐餐品之后，可使用一张该兑换券兑换烤翅(蜜汁)2个。
                        </li>
                        <li>
                            (3)“意面任选7折”折扣券的使用条件：会员在同一笔订单以餐厅菜单售价购买任意达美乐餐品之后，可使用一张该折扣券购买餐厅菜单在售的意面系列中任意一类意面。
                        </li>
                        <li>
                            (4)“黄金薯角一份”兑换券的使用条件：会员在同一笔订单以餐厅菜单售价购买任意达美乐餐品之后，可使用一张该兑换券兑换黄金薯角(125g)餐品一份。
                        </li>
                        <li>
                            5.该渠道入会礼优惠券发放方式：
                        </li>
                        <li>
                            (1)以电子券形式发放；
                        </li>
                        <li>
                            (2)在消费者于达美乐自有线上入会渠道注册成功后并完成选择后,按照达到领取条件的系统时间顺序，发放至消费者手机号对应的达人荟会员账户；
                        </li>
                        <li>
                            (3)系统默认派发的入会礼优惠券，按照达到领取条件的系统时间顺序，发放至消费者手机号对应的达人荟会员账户；
                        </li>
                        <li>
                            (4)入会礼优惠券一经发送不得更改。
                        </li>
                        <li>
                            6.“奖励积分”的使用条件见《会员章程》的“会员积分”章节。积分所兑换的抵扣金额可抵扣订单的实付金额，包括外送费和订单餐品总价。
                        </li>
                        <li>
                            7.奖励积分发放方式：该入会礼的50个奖励积分将在消费者注册成功后加入消费者的达人荟会员帐户对应账户。
                        </li>
                        <li>
                            四、入会礼使用期限：优惠券有效期为自获得之日次日起的60天内；奖励积分（50积分）的有效期限与《会员章程》中的规定一致。
                        </li>
                        <li>
                            五、入会礼使用限制：
                        </li>
                        <li>
                            (一)同一订单中只可享受一项入会礼中优惠券，且不与入会礼活动的其他优惠券同享。
                        </li>
                        <li>
                            (二)会员不得在单笔订单中单独使用入会礼中优惠券，须在同一笔订单以餐厅菜单售价购买任意的达美乐餐品之后，才可以使用一项入会礼中优惠券。
                        </li>
                        <li>
                            (三)每笔订单可使用最多2张优惠券（包括产品兑换券、折扣券或其他优惠券）。除非其它活动另有约定，入会礼优惠券可与其他优惠活动同时享受。
                        </li>
                        <li>
                            (四)优惠券不可转赠、不可折换成现金或积分；如使用优惠券的订单发生退款，仅退还消费者实际支付金额，不退还优惠券的优惠金额且不再补发优惠券。
                        </li>
                        <li>
                            六、如您在成功入会后24小时内未收到入会礼积分，请会员在服务时间段内向达美乐客服中心电话4001-597-597查询和处理。
                        </li>
                        <li class="bold">
                            七、除深圳/广州以外地区所宣传“满150积分折8元，等同于免外送费”，指会员积分满150分即可兑换成8元抵扣优惠，正好抵扣、冲抵除深圳/广州以外地区的外送费8元。
                        </li>
                        <li class="bold">
                            八、深圳/广州地区入会礼所宣传的“150积分折8元，等同于加一元抵外送费”指会员积分满150分即可兑换成8元抵扣优惠，因深圳/广州地区的外送费为9元，则消费者在使用150积兑换了8元抵扣优惠后，可抵扣部分外送费、只需再支付1元的外送费用。
                        </li>
                        <li class="bold">
                            九、会员入会礼相关宣传中“最高价值88元”的构成为：以活动期间餐厅菜单售价作为计算依据、“蜜汁鸡翅一对”兑换券（菜单在售单份4个售价26元，折算后该券价值13元）+“经典风味比萨7折”优惠券的优惠部分（用优惠券购买12寸比萨可享受优惠的价值为86*30%=25.8元）+所赠送的“50积分”的原获取成本价值（订单实付金额50元）=88元。
                        </li>
                        <li class="bold">
                            十、会员入会礼相关宣传中“1元=1积分”和“消费1元积1分”是指：《会员章程》第四条约定的“消费获取积分:
                            消费1元人民币=1积分，不足1元部分四舍五入计算积分。积分计算以会员在达美乐自有订餐渠道、在会员登录状态下的订单实付金额计算,
                            且不含本章程规定不得积分的情况”。提醒您注意不能获取积分的情形。
                        </li>
                    </ul>
                    <h2 style="text-align: right;padding-right: 10px;">
                        达美乐中国
                    </h2>
                </div>

            </template>
        </base-layout>
    </div>
</template>
<script>
	import Vue from 'vue'

	// 隐私协议更新版本日期
	const versionTime = '2019年9月9日';
	const PrivacyProtocolName = '__cache__key__PrivacyProtocol__'

	import baseLayout from "@comm/view/layout/baseLayout";

	export default {
		name: 'systemProtocolDarenExplain',
		props: {
			isShowHeader: {
				type: Boolean,
				default: true
			},
			showTitle: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				versionTime,
				isShowDocs: true
			};
		},
		components: {
			baseLayout
		},
		methods: {
			onShowInfo() {
				this.isShowDocs = !this.isShowDocs;
				this.$nextTick(() => {
					let dialogBox = document.querySelector('.dialog-body');
					let viewBox = document.querySelector('.child-view');
					dialogBox ? dialogBox.scrollTop = '0px' : viewBox.scrollTop = '0px'
				})

			}
		}
	};

	// 版本检查
	function checkVersion() {
		let oldVersionTime = Vue.$localStore.get(PrivacyProtocolName);
		// 对比版本是否一致
		if (oldVersionTime == versionTime) {
			// 表示无更新
			return false;
		}
		// 表示更新
		return true;
	}

	// 更新版本
	function updateVersion() {
		Vue.$localStore.set(PrivacyProtocolName, versionTime);
	}

	export {
		versionTime,
		checkVersion,
		updateVersion,
	}
</script>

<style lang="scss" scoped>

    * {
        font-size: 12px;
    }

    .docs {
        padding: 15px;
        height: 100%;
        overflow-y: scroll;
    }

    h2 {
        color: #333;
        font-size: 18px;
        font-weight: 700;
        padding: 10px 0;
    }

    h3 {
        color: #af1515;
        font-size: 14px;
        font-weight: 700;
        padding: 10px 0;
    }

    .info-text {
        font-size: 14px;
        padding: 5px 0;
    }

    .info-title {
        font-size: 14px;
        font-weight: 700;
    }

    .btn-box {
        text-align: center;
    }

    .btn-back {
        background-color: #dd0404;
        border: none;
        padding: 10px 40px;
        color: #fff;
        border-radius: 5px;

    }

    .btn-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    button.back {
        color: white;
        border: none;
        outline: none;
        width: 100px;
        padding: 5px 10px;
        background-color: red;
    }

    .underline {
        text-decoration: underline;
    }

    .normal {
        font-size: 14px;
    }

    .red {
        /*color: red;*/
    }

    .bold {
        font-weight: bold;
    }

    .padding-top {
        padding-top: 10px;
    }

    p, h3, h2 {
        &.warin {
            color: red;
        }
    }

    .doc-title {
        text-align: center;
    }

    .sub-title {
        font-size: 13px;
    }

    .info-text {
        font-size: 14px;
        padding: 5px 0;
    }

    .info-title {
        font-size: 14px;
        font-weight: 700;
        padding-top: 5px;
    }

    .btn-box {
        text-align: center;

    }

    .btn-back {
        background-color: #dd0404;
        border: none;
        padding: 10px 40px;
        color: #fff;
        border-radius: 5px;

    }

    .btn-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    button.back {
        color: white;
        border: none;
        outline: none;
        width: 100px;
        padding: 5px 10px;
        background-color: red;
    }

    p, h3, h2 {
        &.warin {
            color: red;
        }
    }

    img {
        width: 100%;
    }

    .link {
        font-style: italic;
        text-decoration: underline;
    }

    .bold {
        font-weight: bold;
    }
</style>